var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-aside',{attrs:{"width":"200px"}},[_vm._t("default"),_c('el-left-menu')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }